/**
 * We actually use this icon for todo-lists, not bullet lists - those are ListStars.
 */
export default function IconListBullets1({
  className,
  fill,
  stroke = "currentColor",
}: {
  className?: string
  fill?: string
  stroke?: string
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <path
        d="M9 16.5469C13.168 16.5469 16.5469 13.168 16.5469 9C16.5469 4.83198 13.168 1.45312 9 1.45312C4.83198 1.45312 1.45312 4.83198 1.45312 9C1.45312 13.168 4.83198 16.5469 9 16.5469Z"
        fill={fill}
      />
      <path
        d="M6.48438 3.6084H17.2656"
        stroke={stroke}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.48438 9.3584H17.2656"
        stroke={stroke}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.48438 15.1084H17.2656"
        stroke={stroke}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.89062 2.1709H1.45312C1.05617 2.1709 0.734375 2.49269 0.734375 2.88965V4.32715C0.734375 4.7241 1.05617 5.0459 1.45312 5.0459H2.89062C3.28758 5.0459 3.60938 4.7241 3.60938 4.32715V2.88965C3.60938 2.49269 3.28758 2.1709 2.89062 2.1709Z"
        fill={fill}
        stroke={stroke}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.89062 7.9209H1.45312C1.05617 7.9209 0.734375 8.24276 0.734375 8.63965V10.0771C0.734375 10.4741 1.05617 10.7959 1.45312 10.7959H2.89062C3.28758 10.7959 3.60938 10.4741 3.60938 10.0771V8.63965C3.60938 8.24276 3.28758 7.9209 2.89062 7.9209Z"
        fill={fill}
        stroke={stroke}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.89062 13.6709H1.45312C1.05617 13.6709 0.734375 13.9928 0.734375 14.3896V15.8271C0.734375 16.2241 1.05617 16.5459 1.45312 16.5459H2.89062C3.28758 16.5459 3.60938 16.2241 3.60938 15.8271V14.3896C3.60938 13.9928 3.28758 13.6709 2.89062 13.6709Z"
        fill={fill}
        stroke={stroke}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
